//let BASE_PATH = "http://localhost:4200/";
//let BASE_PATH = "http://192.169.154.20:8082/";
let BASE_PATH = "https://www.beyondthestars.com/";

//let BASE_SERVER_PATH = "http://localhost:57997/";
//let BASE_SERVER_PATH = "http://92.204.139.136:8083/";
let BASE_SERVER_PATH = "https://register.onebeatdance.com/";


export const API_URL = {
  BREAKOUT_WEBPAGE: BASE_SERVER_PATH + 'api/PublicSite/GetWebPageDetails',
  GETWEBPAGE: BASE_SERVER_PATH + 'api/PublicSite/GetWebPage',
  TOURDATE_SERVER_URL: BASE_SERVER_PATH + 'api/PublicSite/GetSeasonEventList',
  GET_Season_URL: BASE_SERVER_PATH + 'api/PublicSite/GetSeasonsList',
  GET_States_URL: BASE_SERVER_PATH + 'api/PublicSite/GetStatesList',
  NATIONALIMAGES_SERVER_URL: BASE_SERVER_PATH + 'api/PublicSite/GetNationalImageList?referenceType=47',
  GET_LIVESTREAM_EVENTS: BASE_SERVER_PATH + 'api/Global/LivestreamURLsForEventType'
};
